import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { tap } from 'rxjs/operators';

// INTERFACES
import { ICreditCard } from '../../../../client/interfaces/client-payment-profile.interface';
import { IPagination } from '../../../interfaces/paginator.interface';

// SERVICES
import { EnvironmentUtilService } from '../../util/environment-util.service';
import { ApiService } from '../api.service';

@Injectable({
  providedIn: 'root',
})
export class ClientPaymentProfileApiService {
  private readonly _pagination = new BehaviorSubject<IPagination>(<IPagination>{});

  environment = this.environmentUtilService.getEnvironment();

  constructor(
    private apiService :ApiService,
    private environmentUtilService :EnvironmentUtilService,
  ) {}

  get(params :{ [param :string] :string | string[] }) :Observable<ICreditCard[]> {
    return this.apiService
      .get(`${this.environment.urlV2}/b2b-portal/payment-profile/cards`, {
        params,
      })
      .pipe(
        tap((res :any) => {
          this._pagination.next(res.meta);
        }),
      );
  }

  create(payload :ICreditCard) :Observable<ICreditCard> {
    return this.apiService.post({
      path: `${this.environment.urlV2}/b2b-portal/payment-profile/cards`,
      body: payload,
    });
  }

  updateLabel(
    id :number,
    payload :{ businessAccountId :number; userId :number; label :string },
  ) :Observable<ICreditCard> {
    return this.apiService.put(
      `${this.environment.urlV2}/b2b-portal/payment-profile/cards/${id}/label`,
      payload,
    );
  }

  delete(
    id :number | undefined,
    payload :{ businessAccountId :number; userId :number },
  ) :Observable<ICreditCard> {
    return this.apiService.delete(
      `${this.environment.urlV2}/b2b-portal/payment-profile/cards/${id}`,
      payload,
    );
  }

  setDefault(
    cardId :number,
    payload :{
      businessAccountId :number;
      userId :number;
    },
  ) :Observable<boolean> {
    return this.apiService.put(
      `${this.environment.urlV2}/b2b-portal/payment-profile/cards/${cardId}`,
      payload,
    );
  }

  get pagination$() :Observable<IPagination> {
    return this._pagination.asObservable();
  }
}
